export default __webpack_public_path__ + "media/images/dashboard_icons/theme-ba1d034972176dc23b680b39d55c68ab.svg";